import React from 'react';
import Box from '@mui/material/Box';
import {
  useBuildType, useGetComplexStatuses, useIsMobile, useLanguageState,
} from 'src/hooks';
import { useCrosstableStatusToggle } from 'src/components/CrosstableContainer/hooks';
import { EFloorType } from 'src/store/view-2d/reducer';
import { useSelector } from 'react-redux';
import { getFloorItemType } from 'src/store/view-2d/selectors';
import { getIsOpenAppartSidebar } from 'src/store/app/selectors';
import { useStyles } from './styles';

export const StatusList: React.FC = () => {
  const styles = useStyles({});
  const { isCrossTable } = useBuildType();
  const { statuses } = useGetComplexStatuses();
  const { currentAppLanguage } = useLanguageState();
  const { isMobileScreen } = useIsMobile();
  const isOpenAppartSidebar = useSelector(getIsOpenAppartSidebar);
  const floorItemType = useSelector(getFloorItemType);
  const { disableStatus, disabledStatusesList } = useCrosstableStatusToggle();
  return (
    <>
      { (!!statuses.length && floorItemType !== EFloorType.list && (!isMobileScreen || (isMobileScreen && !isOpenAppartSidebar))) && (
      <Box
        className={styles.statusList}
        pr={6}
      >
        { statuses.map((status) => (
          <Box
            key={status.id}
            className={styles.crossTableStatus}
            mr={2}
            style={{
              cursor: isCrossTable ? 'pointer' : 'default',
            }}
            onClick={() => disableStatus(status)}
          >
            <Box
              className={styles.crossTableStatusColorWrapper}
              mr={1}
            >
              <Box
                className={styles.crossTableStatusColor}
                bgcolor={isCrossTable ? (status.crosstableColor || status.color) : status.color}
              />
              { isCrossTable && !disabledStatusesList.includes(status) && (
                <Box
                  className={styles.crossTableStatusDot}
                />
              ) }
            </Box>
            <Box
              className={styles.statusListItem}
            >
              { isCrossTable
                ? (status.crosstableName && status.crosstableName[currentAppLanguage])
                : (status.moduleName && status.moduleName[currentAppLanguage]) }
            </Box>
          </Box>
        )) }
      </Box>
      ) }
    </>
  );
};
